export class Deboucer
{
    private timer = 0;
    private debounceTimeInMilliseconds: number;

    constructor(debounceTimeInMilliseconds: number)
    {
        this.debounceTimeInMilliseconds = debounceTimeInMilliseconds;
    }

    public run(callback: () => void)
    {
        window.clearTimeout(this.timer);

        this.timer = window.setTimeout(
            () => callback(),
            this.debounceTimeInMilliseconds,
        );
    }
}
